<template>
  <div class="shop-list">
    <div class="nav">
      <div class="title" @click="$router.replace({ path: '/padAdmin' })">
        智慧优选
      </div>
    </div>

    <!-- 搜索栏 -->
    <div class="search-bar">
      <div class="search-input">
        <input
          type="text"
          v-model="searchKeyword"
          placeholder="请输入商品名称"
        />
        <div class="search-icon" @click="handleSearch">
          <i class="iconfont icon-sousuo"></i>
        </div>
      </div>
    </div>

    <!-- 分类筛选 -->
    <div class="filter-bar">
      <div
        class="filter-item"
        :class="{ active: orderby === 'weigh' }"
        @click="changeorderby('weigh')"
      >
        默认排序
      </div>
      <div
        class="filter-item"
        :class="{ active: orderby === 'price' }"
        @click="changeorderby('price')"
      >
        价格
        <span
          class="sort-arrow"
          :class="{
            asc: orderway === 'asc' && orderby === 'price',
            desc: orderway === 'desc' && orderby === 'price',
          }"
        ></span>
      </div>
      <div
        class="filter-item"
        :class="{ active: orderby === 'sales' }"
        @click="changeorderby('sales')"
      >
        销量
        <span
          class="sort-arrow"
          :class="{
            asc: orderway === 'asc' && orderby === 'sales',
            desc: orderway === 'desc' && orderby === 'sales',
          }"
        ></span>
      </div>
      <div
        class="filter-item"
        :class="{ active: orderby === 'views' }"
        @click="changeorderby('views')"
      >
        浏览量
        <span
          class="sort-arrow"
          :class="{
            asc: orderway === 'asc' && orderby === 'views',
            desc: orderway === 'desc' && orderby === 'views',
          }"
        ></span>
      </div>
      <div
        class="filter-item"
        :class="{ active: orderby === 'comments' }"
        @click="changeorderby('comments')"
      >
        评价数
        <span
          class="sort-arrow"
          :class="{
            asc: orderway === 'asc' && orderby === 'comments',
            desc: orderway === 'desc' && orderby === 'comments',
          }"
        ></span>
      </div>
      <div
        class="filter-item"
        :class="{ active: orderby === 'category' || selectedCategory }"
        @click="showCategoryPicker"
      >
        {{ selectedCategory ? selectedCategory.name : '分类' }}
      </div>
    </div>

    <!-- 商品列表 -->
    <div class="product-list">
      <div class="product-grid">
        <div
          class="product-item"
          v-for="item in displayedProducts"
          :key="item.id"
          @click="goToDetail(item.id)"
        >
          <div class="product-image">
            <img :src="item.image" :alt="item.name" />
            <div class="product-tag" v-if="item.tag">{{ item.tag }}</div>
          </div>
          <div class="product-info">
            <div class="product-name">{{ item.name }}</div>
            <div class="product-desc">{{ item.description }}</div>
            <div class="product-price-section">
              <div class="product-price">
                ¥{{ item.price }}
                <span class="original-price" v-if="item.marketprice">¥{{ item.marketprice }}</span>
              </div>
            </div>
            <div class="product-meta">
              <div class="product-sales">已售{{ item.sales }}件</div>
              <div class="product-views">浏览{{ item.views }}次</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 加载状态 -->
      <div class="loading-status" v-if="isLoading">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>

      <!-- 没有更多数据 -->
      <div class="no-more" v-if="!hasMore && filteredProducts.length > 0">
        <div class="no-more-text">没有更多商品了</div>
      </div>
    </div>

    <!-- 空状态 -->
    <div class="empty-state" v-if="filteredProducts.length === 0">
      <div class="empty-icon">📦</div>
      <div class="empty-text">暂无相关商品</div>
    </div>

    <!-- 分类选择弹窗 -->
    <div class="category-modal" v-if="showCategory" @click="hideCategoryPicker">
      <div class="category-content" @click.stop>
        <div class="category-title">选择设备类型</div>
        <div class="category-list">
          <div class="category-option" @click="selectCategory(null)" :class="{ active: !selectedCategory }">
            全部
          </div>
          <div
            class="category-option"
            v-for="category in categories"
            :key="category.id"
            :class="{
              active: selectedCategory && selectedCategory.id === category.id,
            }"
            @click="selectCategory(category)"
          >
            {{ category.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import idleDetection from '@/mixins/idleDetection';
import { goodsList, allCategory } from '@/api/shop';

export default {
  name: 'ShopList',
  mixins: [idleDetection],
  data() {
    return {
      searchKeyword: '',
      orderby: 'weigh', // weigh, price, sales, views, comments, category
      orderway: 'desc', // asc, desc
      showCategory: false,
      selectedCategory: null,
      pageSize: 20, // 每页显示的商品数量
      currentPage: 1, // 当前页码
      lastPage: 1, // 最后一页页码
      isLoading: false, // 是否正在加载
      products: [],
      categories: [],
    };
  },
  computed: {
    filteredProducts() {
      let result = [...this.products];
      return result;
    },
    displayedProducts() {
      return this.filteredProducts;
    },
    hasMore() {
      // 使用接口返回的分页信息判断是否还有下一页
      console.log('hasMore check:', 'currentPage:', this.currentPage, 'lastPage:', this.lastPage);
      return this.currentPage < this.lastPage;
    },
  },
  methods: {
    // 获取分类列表
    getCategories() {
      allCategory({})
        .then((res) => {
          this.categories = res.data;
          console.log('categories:', this.categories);
        })
        .catch((err) => {
          console.error('获取分类列表失败:', err);
        });
    },
    handleSearch() {
      // 搜索时重置并重新加载数据
      this.loadProducts(1);
    },
    changeorderby(type) {
      if (this.orderby === type) {
        // 如果点击的是当前排序类型，则切换排序顺序
        this.orderway = this.orderway === 'asc' ? 'desc' : 'asc';
      } else {
        // 如果点击的是新的排序类型，则设置为降序
        this.orderby = type;
        this.orderway = 'desc';
      }
      // 每次改变排序时，重新从接口获取第一页数据
      this.loadProducts(1);
    },
    showCategoryPicker() {
      this.showCategory = true;
    },
    hideCategoryPicker() {
      this.showCategory = false;
    },
    selectCategory(category) {
      this.selectedCategory = category;
      this.showCategory = false;
      this.loadProducts(1); // 选择分类后重新加载第一页数据
    },
    goToDetail(id) {
      this.$router.push(`/shop/detail/${id}`);
    },
    // 加载商品数据
    loadProducts(page = 1) {
      console.log('Loading products, page:', page);
      this.isLoading = true;

      goodsList({
        page,
        pageNum: this.pageSize,
        category_id: this.selectedCategory ? this.selectedCategory.id : undefined,
        keyword: this.searchKeyword,
        orderby: this.orderby,
        orderway: this.orderway,
        app_show : 1,
      })
        .then((res) => {
          console.log('API response:', res);
          if (page === 1) {
            // 如果是第一页，替换现有数据
            this.products = res.data.data;
          } else {
            // 如果是后续页，追加数据
            this.products = [...this.products, ...res.data.data];
          }
          this.currentPage = res.data.current_page;
          this.lastPage = res.data.last_page;
          console.log('Pagination updated:', 'currentPage:', this.currentPage, 'lastPage:', this.lastPage);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadMore() {
      if (this.isLoading) return;

      console.log('Loading more, next page:', this.currentPage + 1);
      this.loadProducts(this.currentPage + 1);
    },
    handleScroll() {
      // 获取滚动容器
      const productList = document.querySelector('.product-list');
      if (!productList) return;

      // 检查是否滚动到底部附近（提前100px触发）
      const { scrollTop, scrollHeight, clientHeight } = productList;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100;

      // 如果接近底部且还有更多数据且不在加载中，则加载更多
      if (isNearBottom && this.hasMore && !this.isLoading) {
        console.log('Trigger loadMore');
        this.loadMore();
      }
    },
  },
  mounted() {
    // 初始化加载商品数据
    this.loadProducts();

    // 获取分类列表
    this.getCategories();

    // 添加滚动事件监听
    const productList = document.querySelector('.product-list');
    if (productList) {
      productList.addEventListener('scroll', this.handleScroll);
    }
  },
  beforeDestroy() {
    // 移除滚动事件监听
    const productList = document.querySelector('.product-list');
    if (productList) {
      productList.removeEventListener('scroll', this.handleScroll);
    }
  },
  // 移除导致无限加载的 watch 监听器

};
</script>

<style scoped lang="scss">
.shop-list {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: 70px 40px 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;

  .nav {
    font-family: 'YouSheBiaoTiHei';
    color: #ffffff;
    font-weight: 400;
    font-size: 56px;
    margin-bottom: 45px;
    position: relative;

    .title {
      display: inline-block;
      padding: 12px 50px 0;
      cursor: pointer;

      &::before {
        content: '';
        width: 30px;
        height: 30px;
        border-top: 5px solid transparent;
        border-bottom: 5px solid #fff;
        border-right: 5px solid transparent;
        border-left: 5px solid #fff;
        position: absolute;
        top: 50%;
        left: 0;
        transform: rotate(45deg) translateY(-50%);
      }
    }
  }

  .search-bar {
    margin-bottom: 35px;

    .search-input {
      position: relative;
      width: 100%;
      height: 90px;

      input {
        width: 100%;
        height: 100%;
        padding: 0 110px 0 35px;
        font-size: 32px;
        border-radius: 45px;
        border: none;
        background-color: #fff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        &::placeholder {
          color: #999;
        }
      }

      .search-icon {
        position: absolute;
        right: 35px;
        top: 50%;
        transform: translateY(-50%);
        width: 45px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;

        .iconfont {
          font-size: 40px;
          color: #0066cc;
        }
      }
    }
  }

  .filter-bar {
    display: flex;
    background-color: #fff;
    border-radius: 24px;
    padding: 15px;
    margin-bottom: 35px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

    .filter-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 70px;
      font-size: 28px;
      color: #666;
      border-radius: 20px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 15px;

      &.active {
        background-color: #0066cc;
        color: #fff;
      }

      .sort-arrow {
        margin-left: 10px;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;

        &.asc {
          border-bottom: 10px solid #fff;
        }

        &.desc {
          border-top: 10px solid #fff;
        }
      }

      .category-text {
        margin-left: 10px;
        font-size: 24px;
      }
    }
  }

  .product-list {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    width: 100%;

    .product-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
      width: 100%;
      box-sizing: border-box;

      .product-item {
        background-color: #fff;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        cursor: pointer;
        transition: transform 0.3s ease;

        &:hover {
          transform: translateY(-5px);
        }
      }

      .product-image {
        position: relative;
        height: 485px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .product-tag {
          position: absolute;
          top: 20px;
          left: 20px;
          padding: 12px 20px;
          background-color: #ff6b6b;
          color: #fff;
          font-size: 24px;
          border-radius: 24px;
        }
      }

      .product-info {
        padding: 25px;

        .product-name {
          font-size: 34px;
          font-weight: 600;
          color: #333;
          margin-bottom: 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .product-desc {
          font-size: 26px;
          color: #666;
          margin-bottom: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .product-price-section {
          margin-bottom: 15px;

          .product-price {
            font-size: 40px;
            font-weight: 600;
            color: #ff6b6b;

            .original-price {
              font-size: 30px;
              color: #999;
              text-decoration: line-through;
              margin-left: 15px;
            }
          }
        }

        .product-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;

          .product-sales {
            font-size: 24px;
            color: #999;
          }

          .product-views {
            font-size: 24px;
            color: #999;
          }
        }

        .product-comments {
          display: flex;
          align-items: center;

          .comments-stars {
            display: flex;
            margin-right: 10px;

            .star {
              width: 20px;
              height: 20px;
              margin-right: 4px;
              background-color: #ddd;
              clip-path: polygon(
                50% 0%,
                61% 35%,
                98% 35%,
                68% 57%,
                79% 91%,
                50% 70%,
                21% 91%,
                32% 57%,
                2% 35%,
                39% 35%
              );

              &.filled {
                background-color: #ffd700;
              }
            }
          }

          .comments-count {
            font-size: 22px;
            color: #999;
          }
        }
      }
    }
  }

  .loading-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0;

    .loading-spinner {
      width: 50px;
      height: 50px;
      border: 5px solid #f3f3f3;
      border-top: 5px solid #0066cc;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-bottom: 20px;
    }

    .loading-text {
      font-size: 28px;
      color: #999;
    }
  }

  .no-more {
    padding: 40px 0;
    text-align: center;

    .no-more-text {
      font-size: 28px;
      color: #999;
    }
  }

  .category-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .category-content {
      width: 700px;
      background-color: #fff;
      border-radius: 24px;
      padding: 40px;

      .category-title {
        font-size: 36px;
        font-weight: 600;
        color: #333;
        margin-bottom: 40px;
        text-align: center;
      }

      .category-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 25px;

        .category-option {
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          color: #666;
          border: 1px solid #ddd;
          border-radius: 20px;
          cursor: pointer;
          transition: all 0.3s ease;

          &.active {
            background-color: #0066cc;
            color: #fff;
            border-color: #0066cc;
          }
        }
      }
    }
  }

  .load-more {
    margin: 30px 0;
    text-align: center;

    .load-more-btn {
      width: 350px;
      height: 90px;
      background-color: #0066cc;
      color: #fff;
      font-size: 32px;
      border: none;
      border-radius: 45px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:disabled {
        background-color: #ccc;
        cursor: not-allowed;
      }

      &:not(:disabled):hover {
        background-color: #0052a3;
      }
    }
  }

  .no-more {
    margin: 30px 0;
    text-align: center;

    .no-more-text {
      font-size: 28px;
      color: #999;
    }
  }

  .empty-state {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    .empty-icon {
      font-size: 100px;
      margin-bottom: 30px;
    }

    .empty-text {
      font-size: 34px;
      color: #999;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
